import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
const Entry = (_param)=>{
    var { mention, theme, searchValue, isFocused } = _param, parentProps = _object_without_properties(_param, [
        "mention",
        "theme",
        "searchValue",
        "isFocused"
    ]);
    return /*#__PURE__*/ React.createElement("div", parentProps, /*#__PURE__*/ React.createElement("div", {
        className: theme.mentionSuggestionsEntryContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: theme.mentionSuggestionsEntryContainerLeft
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "",
        src: cleanLinkSrc(mention.avatar),
        className: theme.mentionSuggestionsEntryAvatar,
        role: "presentation",
        loading: "lazy"
    })), /*#__PURE__*/ React.createElement("div", {
        className: theme.mentionSuggestionsEntryContainerRight
    }, /*#__PURE__*/ React.createElement("div", {
        className: theme.mentionSuggestionsEntryText
    }, mention.name))));
};
Entry.displayName = 'MentionEntry';
export default Entry;

//# sourceMappingURL=Entry.js.map